import {
  AppBar,
  Box,
  CardMedia,
  Container,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
  Dialog,
  Button,
  Stack,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogProps,
  Divider,
  InputAdornment,
  Menu,
  MenuItem,
  Select,
  FormControl,
  Grid,
  Tooltip,
} from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  ApplicationsIcon,
  FundsSetup,
  RiskProfile,
  AMCAdmins,
  Reports,
  DashboardIcon,
} from './customSVGs';
import { useRouteMatch } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { logout, showError } from '../redux-store/actions/auth';
import MenuIcon from '@mui/icons-material/Menu';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExitToApp from '@mui/icons-material/ExitToApp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CancelIcon from '@mui/icons-material/Cancel';
import { RootStateType } from '../redux-store/reducers';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import {
  APPLICATION_TYPE,
  ENABLE_Email_Consent,
  USER_ROLES,
  InvalidCommentsMessage,
  ENABLE_USER_EXPORT,
} from '../utils/constant';
import ArrowDropDownSharpIcon from '@mui/icons-material/ArrowDropDownSharp';
import { Formik, useField, useFormikContext } from 'formik';
import {
  checkValidationBasedOnDate,
  applicationComparison,
  getCountryCodes,
} from '../utils/utilityFunctions';
import {
  Applicant,
  AuthorisedSignatories,
  DocumentType,
  FileType,
  investmentDetailsAplicationRef,
  ApplicationProps,
  tinValidationProps,
} from '../redux-store/types/api-types';
import { Gridstyles, Item, ItemDetails } from './ApplicationDetails';
import { SubHeading } from './investors/components';
import { KeyValue } from './ApplicationDetails/contributor';
import { JsxAttributeLike } from 'typescript';
import * as yup from 'yup';
import { MFTextField } from '../lib/formik';
import MFCheckbox from '../lib/formik/Checkbox';
import { useHistory } from 'react-router';
import { getParams } from '../redux-store/actions/application';
import { initialState } from '../redux-store/reducers/queryParams';
import {
  renderFilteredOptions,
  getSearchableSelectMenuProps,
} from '../lib/formik/searchSelectField';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { getAdminMakerCheckerParams } from '../redux-store/actions/userFundsVerification';
import { initialStateForAdminMakerChecker } from '../redux-store/reducers/queryParamsForAdminMakerChecker';
import CloseIcon from '@mui/icons-material/Close';
import { validCommentRegex } from '../utils/regex';
import { getFieldTitle } from './ApplicationDetails/DocumentDetails';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
// import { documentDetails } from './investors/documentDetails';
// import { LoadingButton } from '@mui/lab';
import { reportDownload } from './Reports/report-utils';
import { exportUsersData } from '../redux-store/actions/userManagement';
import { LoadingButton } from '@mui/lab';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { newDocumentProps, document_object, documentDetails } from './investors/documentDetails';
import MFSelectField from '../lib/formik/SelectField';
import { FileUpload } from './NonIndividualInvestor/DocumentDetails';
import { Values } from './NonIndividualInvestor/fatca';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { DocumentPreview } from './ApplicationDetails/DocumentDetails';
import { useFeatureToggles } from '../utils/toggler';
import { getDocumentActionAriaLabel } from '../utils/documentAccessibility';
import { getEsignLinkCopyAriaLabel } from '../utils/applicationAccessibility';

export function OtpTimer({ onResend }: { onResend: () => void }): JSX.Element {
  const [counter, setCounter] = useState(60);

  // Third Attempts
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const timer: any = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  return (
    <Box>
      <Typography>
        <Button
          sx={{
            color: 'primary.main',
            mt: 2,
            fontSize: 16,
            fontWeight: 500,
            p: 0,
            ':hover': {
              background: 'none',
            },
          }}
          disabled={counter > 0}
          onClick={() => {
            try {
              onResend();
              setCounter(60);
            } catch (e) {
              console.error((e as Error).message);
            }
          }}>
          Resend OTP
        </Button>
        <br />
        {counter > 0 && `in ${counter} seconds`}
      </Typography>
    </Box>
  );
}

// Footer
export const Footer = (): JSX.Element => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        display: 'flex',
        justifyContent: 'center',
        py: 1,
      }}>
      <Typography sx={{ color: 'common.white' }}>Powered By </Typography>
      <CardMedia
        component="img"
        src="/images/kfin-new-logo.png"
        alt="kFintech Logo"
        sx={{ width: 'unset' }}
      />
    </Box>
  );
};
// Footer End

// Login Layout
export const LoginLayout = ({
  LoginText,
  children,
}: {
  LoginText: string;
  children: JSX.Element;
}): JSX.Element => {
  return (
    <>
      <a
        href="#main-content"
        className="skip-link"
        onClick={(e) => {
          e.preventDefault();
          const mainContent = document.getElementById('main-content');
          if (mainContent) {
            mainContent.focus();
            // Focus first focusable element inside main content

            const target = document.getElementById('mobileNumber');
            if (target) {
              target.focus();
            }
          }
        }}>
        Skip to main content
      </a>
      <Stack
        sx={{
          minHeight: '100vh',
          background: '#f2f6f8 url("/images/login-bg.svg")',
          backgroundSize: 'cover',
        }}>
        <AppBar elevation={0} position="static" sx={{ bgcolor: 'transparent' }}>
          <Box>
            <CardMedia
              component="img"
              src="/images/kotak-logo.png"
              alt="Kotak Alternate Asset Managers"
              sx={{ width: '190px', m: 3, mt: 1 }}
            />
          </Box>
        </AppBar>

        <Box
          // tabIndex={0}
          id="main-content"
          component="main"
          sx={{
            // height: 'calc(100vh - 43px)',
            flex: 1,
            display: 'grid',
            placeItems: 'center',
            // mt: '-88px',
            ':focus-visible': {
              outline: '2px solid #153760',
              outlineOffset: '2px',
            },
          }}>
          <Box
            sx={{
              bgcolor: 'grey.50',
              height: { xs: 'unset', sm: 'unset' },
              minHeight: { xs: 'unset', sm: '470px' },
              width: 'clamp(300px, 70%, 500px)',
              px: { xs: '25px', sm: '80px' },
              py: '50px',
              mb: 2,
              borderRadius: '10px',
              boxShadow: '0px 3.29214px 6.58427px rgba(27, 27, 27, 0.16)',
            }}>
            <Typography
              component="h1"
              variant="h5"
              sx={{
                fontFamily: 'Poppins, sans-serif',
                fontSize: 28,
                fontWeight: 600,
                color: 'primary.main',
                mb: '50px',
                textAlign: 'center',
              }}>
              {LoginText}
            </Typography>
            {children}
          </Box>
        </Box>

        {/* <Footer /> */}
      </Stack>
    </>
  );
};
// Login Layout End

// Header & Sidenav
const drawerWidth = '169px';

const MenuButton = ({
  to = null,
  text,
  children,
  downArrow,
  onClick,
  ariaExpanded,
}: {
  to?: string | null;
  text: string;
  children: JSX.Element;
  downArrow?: boolean;
  onClick?: () => void;
  ariaExpanded?: boolean;
}) => {
  const { path } = useRouteMatch();
  const match = to
    ? path.includes(to)
    : to !== '' &&
      [
        '/onboarding',
        '/applications',
        '/application',
        '/application-details/:id',
        '/non-individual-application-details/:id',
        '/non-individual-application',
        '/application-preview/:id',
        '/non-individual-application-preview/:id',
      ].includes(path);
  const disabled = to === null;
  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={onClick}
        component={disabled ? Typography : RouterLink}
        to={to || ''}
        {...(match && !disabled ? { 'aria-current': 'page' as const } : {})}
        {...(ariaExpanded !== undefined
          ? { 'aria-expanded': ariaExpanded ? 'true' : 'false' }
          : {})}
        sx={{
          p: { xs: '10px 20px', md: 3 },
          borderLeft: '3px solid',
          borderLeftColor: match ? 'primary.main' : 'transparent',
          background: match
            ? 'linear-gradient(88.93deg, rgba(51, 127, 201, 0.10) 24.43%, rgba(51, 127, 201, 0) 93.37%)'
            : 'transparent',
          color: match ? 'primary.main' : 'secondary.main',
          stroke: match ? '#2057A6' : '#131836',
          strokeWidth: 0,
          '.MuiSvgIcon-root ': {
            opacity: match ? 1 : 0.5,
          },
          '& .MuiListItemText-root span': {
            fontWeight: match ? 700 : 500,
            textDecoration: match ? 'underline' : 'none',
            textUnderlineOffset: '4px',
          },
          ':hover': {
            background: match
              ? 'linear-gradient(88.93deg, rgba(51, 127, 201, 0.10) 24.43%, rgba(51, 127, 201, 0) 93.37%)'
              : 'transparent',
          },
          textAlign: 'center',
          // pointerEvents: text === 'Funds Setup' ? 'none' : 'all',
          '&:focus-visible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
          },
        }}>
        {children}
        <ListItemText
          primary={text}
          secondary={downArrow && <ExpandMoreIcon aria-label="Open Applications Menu " />}
        />
      </ListItemButton>
    </ListItem>
  );
};

const KfinDrawer = ({ onToggleClick }: { onToggleClick: () => void }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { role = '', adminSupport } = useSelector((store: RootStateType) => store.auth);

  return (
    <Box>
      <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end' }}>
        <IconButton onClick={onToggleClick} aria-label="close drawer" sx={{ color: '#00D9DA' }}>
          <CancelIcon />
        </IconButton>
      </Box>
      <List
        sx={{
          pt: { xs: 2, md: 1 },
          '& .MuiListItemButton-root': {
            mb: 1,
            flexDirection: { xs: 'row', md: 'column' },
            '& .MuiListItemText-root': { mx: { xs: 1, md: 0 } },
            '& .MuiListItemText-root span': {
              fontFamily: 'Poppins, sans-serif',
              fontSize: 16,
              fontWeight: 500,
            },
          },
        }}>
        <MenuButton to="/dashboard" text="Dashboard">
          <DashboardIcon />
        </MenuButton>
        <MenuButton
          text="Applications"
          downArrow={!open}
          onClick={() => setOpen(!open)}
          ariaExpanded={open}>
          <ApplicationsIcon />
        </MenuButton>
        {open && (
          <ListItem disablePadding sx={{ display: 'block' }}>
            <Box
              // tabIndex={0}
              sx={{
                textAlign: 'center',
                '.MuiTypography-root': {
                  my: 1,
                  py: 1,
                  fontWeight: 500,
                  fontSize: 14,
                  display: 'block',
                  textDecoration: 'none',
                  color: 'text.primary',
                  background:
                    'linear-gradient(90deg, rgba(15, 212, 216, 0.072) 0%, rgba(97, 209, 214, 0) 100%)',
                },
              }}>
              <Typography
                component={RouterLink}
                to="/onboarding"
                onClick={() => dispatch(getParams(initialState))}
                sx={{
                  color: 'inherit',
                  display: 'inline',
                  textDecoration: location.pathname.startsWith('/onboarding')
                    ? 'underline !important'
                    : 'none',
                  textUnderlineOffset: '4px',
                }}>
                Add New
              </Typography>
              <Typography
                component={RouterLink}
                to="/applications"
                onClick={() => dispatch(getParams(initialState))}
                sx={{
                  color: 'inherit',
                  display: 'inline',
                  textDecoration: location.pathname.startsWith('/applications')
                    ? 'underline !important'
                    : 'none',
                  textUnderlineOffset: '4px',
                }}>
                View Existing
              </Typography>
              {ENABLE_Email_Consent && (
                <Typography component={RouterLink} to="/view-consent-email-list">
                  View Email Consent
                </Typography>
              )}
              <IconButton onClick={() => setOpen(!open)} aria-label="Collapse Applications menu">
                <ExpandLessIcon sx={{ color: 'primary.main' }} />
              </IconButton>
            </Box>
          </ListItem>
        )}
        {USER_ROLES.AMC_ADMIN === role && (
          <>
            <MenuButton text="User Management" to="/user-management">
              <PersonOutlineOutlinedIcon />
            </MenuButton>
            <MenuButton text="Funds Setup" to="/funds-setup">
              <FundsSetup />
            </MenuButton>
            <MenuButton text="Reports" to="/reports">
              <Reports />
            </MenuButton>
            <MenuButton
              text="Users & Funds Verification"
              to="/users-funds-verification"
              onClick={() => {
                dispatch(getAdminMakerCheckerParams(initialStateForAdminMakerChecker));
              }}>
              <AdminPanelSettingsIcon />
            </MenuButton>
            <MenuButton text="Document Setup" to="/documents-setup">
              <FileCopyIcon />
            </MenuButton>
            {adminSupport && (
              <MenuButton text="Admin Support" to="/admin-support">
                <RiskProfile />
              </MenuButton>
            )}
            {/* <MenuButton text="Risk Profile" to="/risk-profile">
              <RiskProfile />
            </MenuButton> */}
          </>
        )}
        {USER_ROLES.SUPER_ADMIN === role && (
          <MenuButton text="AMC Admins" to="/amc-admins">
            <AMCAdmins />
          </MenuButton>
        )}
        {/* <MenuButton to="" text="Settings">
          <SettingsIcon />
        </MenuButton> */}
      </List>
    </Box>
  );
};

export const HeaderSidenav = (): JSX.Element => {
  const dispatch = useDispatch();
  // const history = useHistory();
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: 'white',
          boxShadow: 'none',
          zIndex: 1100,
          width: '100%',
          maxWidth: '100vw',
          overflow: { xs: 'hidden', sm: 'visible' },
        }}>
        <Toolbar sx={{ px: { xs: 1, lg: 6 }, minWidth: 0, width: '100%', maxWidth: '100%' }}>
          <Box sx={{ mr: 'auto', minWidth: 0, flexShrink: 1 }}>
            <CardMedia
              component="img"
              src="/images/kotak-logo.png"
              alt="Kotak Alternate Asset Managers"
              sx={{
                width: { xs: '130px', sm: '190px' },
                maxWidth: '100%',
                height: 'auto',
                my: 1.2,
              }}
            />
          </Box>
          {/* <Box sx={{ display: 'flex' }}>
            <IconButton onClick={() => history.push('/profile')}>
              <AccountCircleIcon fontSize="large" sx={{ color: 'primary.main' }} />
            </IconButton>
          </Box> */}
          <Box sx={{ display: 'flex' }}>
            <IconButton
              aria-label="Log out"
              disableRipple
              sx={{
                '&:focus-visible': {
                  outline: '2px solid #153760',
                  outlineOffset: '2px',
                },
              }}
              onClick={() => dispatch(logout())}>
              <ExitToApp fontSize="large" sx={{ color: 'primary.main' }} />
            </IconButton>
          </Box>
          <IconButton
            aria-label="Open menu"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { md: 'none' }, color: 'secondary.main' }}>
            <MenuIcon aria-label="Open Menu" />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
        aria-label="Side">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          anchor="right"
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}>
          <KfinDrawer onToggleClick={() => setMobileOpen(!mobileOpen)} />
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', md: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              mt: '100px',
              border: 0,
              maxHeight: 'calc(100vh - 100px)',
              overflow: 'scroll',
              // pb: 'calc(65px + 10%)',
              // justifyContent: 'center',
            },
          }}
          open>
          <div>
            <KfinDrawer onToggleClick={() => setMobileOpen(!mobileOpen)} />
          </div>
        </Drawer>
      </Box>
    </>
  );
};
// Header & Sidenav END

export const CommonLayout = ({ children }: { children: JSX.Element }): JSX.Element => {
  return (
    <>
      <a
        href="#main-content"
        className="skip-link"
        onClick={(e) => {
          e.preventDefault();
          const mainContent = document.getElementById('main-content');
          if (mainContent) {
            mainContent.focus();
            // Focus first focusable element inside main content
            const firstFocusable = mainContent.querySelector(
              'input, select, button, textarea, [tabindex]:not([tabindex="-1"])'
            );
            if (firstFocusable) {
              (firstFocusable as HTMLElement).focus();
            }
          }
        }}>
        Skip to main content
      </a>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'column',
          width: '100%',
          overflowX: 'hidden',
        }}>
        <HeaderSidenav />

        <Box
          // tabIndex={0}
          id="main-content"
          component="main"
          sx={{
            mt: '65px',
            ml: { xs: 0, md: drawerWidth },
            p: { xs: 1.5, sm: 2, md: '50px' },
            pt: { md: '20px' },
            borderRadius: '50px 0 0 0',
            bgcolor: { xs: '', md: 'rgba(238, 244, 251, 0.5)' },
            minHeight: 'calc(100vh - 108px)',
            width: { xs: '100%', md: `calc(100% - ${drawerWidth})` },
            minWidth: 0,
            overflowX: 'hidden',
            boxSizing: 'border-box',
            ':focus-visible': {
              outline: '2px solid #153760',
              outlineOffset: '2px',
            },
          }}>
          <Container
            maxWidth="lg"
            disableGutters
            sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
            {children}
          </Container>
        </Box>
      </Box>
      {/* <Footer /> */}
    </>
  );
};

export const UserManagementCommonLayout = ({
  children,
  showButton,
}: {
  children: JSX.Element;
  showButton: boolean;
}): JSX.Element => {
  const [isSendLoading, setIsSendLoading] = useState(false);
  const dispatch = useDispatch();

  const downloadUsersData = async () => {
    try {
      setIsSendLoading(true);
      const res = await dispatch(exportUsersData());
      reportDownload(res as unknown as Blob, 'aif-onboarding-users.xlsx');
    } catch (e) {
      setIsSendLoading(false);
      console.error((e as Error).message);
    } finally {
      setIsSendLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'column',
          width: '100%',
          overflowX: 'hidden',
        }}>
        <HeaderSidenav />
        <Box
          component="main"
          sx={{
            mt: '65px',
            ml: { xs: 0, md: drawerWidth },
            p: { xs: 0, md: '50px' },
            pt: { md: '20px' },
            borderRadius: { xs: '', sm: '50px 0 0 0' },
            bgcolor: 'rgba(238, 244, 251, 0.5)',
            minHeight: 'calc(100vh - 108px)',
            width: { xs: '100%', md: `calc(100% - ${drawerWidth})` },
            minWidth: 0,
            overflowX: 'hidden',
            boxSizing: 'border-box',
          }}>
          <Container
            maxWidth="lg"
            disableGutters
            sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
            {showButton && ENABLE_USER_EXPORT && (
              <Box sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-end' } }}>
                <Tooltip title="Click here to download users data">
                  <LoadingButton
                    loadingPosition="start"
                    type="submit"
                    loading={isSendLoading}
                    variant="contained"
                    sx={{
                      fontSize: 12,
                      minWidth: isSendLoading ? 220 : '',
                      letterSpacing: 1,
                      fontWeight: 400,
                      px: isSendLoading ? 0 : 2,
                      py: 1,
                      mt: 1,
                    }}
                    onClick={downloadUsersData}>
                    Download Users Data
                  </LoadingButton>
                </Tooltip>
              </Box>
            )}
            {children}
          </Container>
        </Box>
      </Box>
      {/* <Footer /> */}
    </>
  );
};
export const ConfirmationDialog = ({
  open,
  setOpen,
  message = 'Are you sure you want to delete?',
  onCancel,
  onSave,
  displayInfo,
}: {
  message: string;
  open: boolean;
  setOpen: () => void;
  onCancel: () => void;
  onSave: () => void;
  displayInfo?: string;
}): JSX.Element => {
  return (
    <Dialog open={open} onClose={setOpen}>
      <Box
        sx={{
          p: { xs: 2, sm: '45px 40px' },
          borderRadius: '10px',
          // width: { xs: '70%', sm: '70%' },
          maxWidth: 400,
          height: { xs: '90%', md: 'unset' },
          overflowY: 'auto',
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            '& .MuiButton-root': {
              minWidth: 100,
              fontSize: 16,
            },
          }}>
          {displayInfo && (
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 500,
                color: '#d32f2f',
                textAlign: 'center',
                mb: 5,
              }}>
              {displayInfo}
            </Typography>
          )}
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 500,
              color: '#3179C0',
              textAlign: 'center',
              mb: 5,
            }}>
            {message}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              '.MuiButton-root': {
                minWidth: '100px',
              },
            }}>
            <Button variant="contained" onClick={onSave} sx={{ color: 'common.white' }}>
              Yes
            </Button>
            <Button variant="outlined" onClick={onCancel} sx={{ color: 'primary.main' }}>
              No
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

type Props = DialogProps & {
  title?: string;
  content: string;
  ariaLabel?: string;
  actions: {
    label: string;
    onClick: () => void;
  }[];
};

export default function SimpleDialog({
  title,
  ariaLabel,
  content,
  actions,
  TransitionProps,
  PaperProps: paperProps,
  ...dialogProps
}: Props): JSX.Element {
  const firstActionRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog
      {...dialogProps}
      aria-labelledby={title ? 'simple-dialog-title' : undefined}
      disableAutoFocus
      PaperProps={{
        ...paperProps,
        role: 'alertdialog',
        ...(title
          ? { 'aria-labelledby': 'simple-dialog-title' }
          : { 'aria-label': ariaLabel || content, 'aria-labelledby': undefined }),
      }}
      TransitionProps={{
        ...TransitionProps,
        onEntered: (...args) => {
          firstActionRef.current?.focus();
          TransitionProps?.onEntered?.(...args);
        },
      }}
      sx={{
        '& .MuiPaper-root': {
          minWidth: { sx: '300px', md: '400px' },
          maxWidth: { sx: '500px', md: '500px' },
          borderRadius: '8px',
          padding: '30px 30px 20px',
          textAlign: 'center',
          color: '#4f4f4f',
        },
        '& .MuiDialogContent-root': {
          textAlign: 'center',
        },
        '& .MuiDialogActions-root': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiButton-root': {
            width: '160px',
            height: '58px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '18px',
            margin: 'auto',
            marginBottom: '20px',
          },
        },
        '&.Mui-focusVisible': {
          outline: '2px solid #000',
          outlineOffset: '2px',
          boxShadow: '0px 0px 0px 2px #FFFFFF, 0px 0px 0px 4px #000000',
        },
      }}>
      {title && <DialogTitle id="simple-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {actions.map((action, index) => (
          <Button
            ref={index === 0 ? firstActionRef : undefined}
            variant="contained"
            color="primary"
            key={index}
            onClick={action.onClick}
            disableRipple
            sx={{
              '&.Mui-focusVisible': {
                outline: '2px solid #000',
                outlineOffset: '2px',
                boxShadow: 'none',
              },
            }}>
            {action.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
}

export function CommonLayoutForPOA(): JSX.Element {
  const { role } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  return (
    <>
      <AppBar position="fixed" elevation={0} sx={{ bgcolor: 'common.white' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingRight: { xs: 0, sm: '48px' },
            paddingLeft: { xs: 0, sm: '48px' },
          }}>
          <CardMedia
            component="img"
            src="/images/kotak-logo.png"
            alt="Kotak Alternate Asset Managers"
            sx={{ width: '190px', m: 3, my: 1 }}
          />
          {![
            USER_ROLES.INVESTOR,
            USER_ROLES.AUTHORISEDSIGNATORY,
            USER_ROLES.GROUPSIGNATORY,
          ].includes(role) && (
            <Box sx={{ display: 'flex' }}>
              <IconButton onClick={() => dispatch(logout())} aria-label="Log out">
                <ExitToApp fontSize="large" sx={{ color: 'primary.main' }} />
              </IconButton>
            </Box>
          )}
        </Box>
      </AppBar>
      <Divider sx={{ display: { xs: 'block', sm: 'none' } }} />
    </>
  );
}

const getCountryCodeDisplayValue = (countryValue: string): string =>
  countryValue?.split(':')[1] ? countryValue.split(':')[1].trim() : countryValue || '';

export function CountryCodesDropDown({
  name,
  value,
  readOnly = false,
  disabled = false,
  ElementWidth,
  ariaLabel = 'Country Code',
}: {
  name: string;
  value: string;
  readOnly?: boolean;
  disabled?: boolean;
  ElementWidth?: number | null;
  ariaLabel?: string;
}): JSX.Element {
  const { setFieldValue } = useFormikContext();
  const [query, setQuery] = useState('');
  const displayValue = getCountryCodeDisplayValue(value);
  const selectAccessibleName = displayValue ? `${ariaLabel}, ${displayValue}` : ariaLabel;

  return (
    <InputAdornment
      position="start"
      sx={{
        pr: '0 !important',
        mx: '0 !important',
      }}>
      <Box
        sx={{
          flexShrink: 0,
          '.MuiOutlinedInput-root': {
            marginTop: '0',
            '&.MuiInputBase-root': {
              '& .MuiSelect-select': {
                padding: '12px 24px 12px 0',
                border: 'none',
                minWidth: 28,
              },
            },
            '.MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '.MuiSelect-icon': {
              right: 0,
            },
            '&.Mui-focusVisible, &:has(.MuiSelect-select:focus-visible)': {
              outline: '2px solid #153760',
              outlineOffset: '2px',
              borderRadius: '4px',
            },
          },

          '&.Mui-focused,&:hover': {
            '.MuiOutlinedInput-notchedOutline': {
              borderWidth: 'none',
            },
          },
          svg: {
            color: '#3179C0',
          },
        }}>
        <Select
          onChange={(e) => {
            setFieldValue(name, `${e.target.value}`);
          }}
          value={value}
          renderValue={(selectedValue) => {
            return (
              <Typography component="span" aria-hidden="true" sx={{ whiteSpace: 'nowrap' }}>
                {getCountryCodeDisplayValue(selectedValue as string)}
              </Typography>
            );
          }}
          MenuProps={getSearchableSelectMenuProps(
            {
              searchFieldPlaceholder: 'Search...',
              setQuery,
              ariaLabel: 'Search country code',
              listboxAriaLabel: 'Country code options',
              searchInputId: `${name}-country-code-search`,
            },
            {
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
              sx: {
                '.MuiPaper-root ': {
                  width: ElementWidth,
                  ml: '-10px',
                  maxHeight: 'min(320px, 50vh)',
                  overflowY: 'auto',
                },
              },
            }
          )}
          onClose={() => {
            setQuery('');
          }}
          SelectDisplayProps={{
            'aria-label': selectAccessibleName,
            'aria-labelledby': undefined,
          }}
          readOnly={readOnly}
          disabled={disabled}>
          {renderFilteredOptions(
            getCountryCodes().map((codes) => ({
              key: codes.label,
              value: codes.label,
            })),
            query
          )}
          {/* {getCountryCodes().map((codes, ind) => (
            <MenuItem value={codes.label} key={ind}>
              {codes.label}
            </MenuItem>
          ))} */}
        </Select>
      </Box>
    </InputAdornment>
  );
}
export interface AmlPopupValues {
  amlComments: string;
  amlAcknowledgement: boolean;
}

const amlPopupInitialValues: AmlPopupValues = {
  amlComments: '',
  amlAcknowledgement: false,
};
const amlPopupValidation = yup.object().shape({
  amlComments: yup
    .string()
    .nullable()
    .matches(validCommentRegex, InvalidCommentsMessage)
    .required('Field is required'),
  amlAcknowledgement: yup.bool().test('amlAcknowledgement', 'Field is required', (value) => {
    return value || false;
  }),
});
export function AmlPopup({
  handleClose,
  amlPopupOpen,
  onSubmit,
  FURTHER_INFORMATION,
  EXTERNAL_SOURCES,
  displayDocInfo = false,
}: {
  handleClose: () => void;
  amlPopupOpen: boolean;
  onSubmit: (values: AmlPopupValues) => void;
  FURTHER_INFORMATION?: string;
  EXTERNAL_SOURCES?: string;
  displayDocInfo?: boolean;
}): JSX.Element {
  return (
    <Dialog
      onClose={handleClose}
      open={amlPopupOpen}
      sx={{
        '.MuiPaper-root ': {
          p: 2,
          width: { xs: '100%', sm: '70%' },
        },
      }}>
      <Box sx={{ mb: 2, mt: 1 }}>
        <CardMedia
          component="img"
          src="/images/warning-icon-red.svg"
          sx={{ width: '50px', mx: 'auto' }}
        />
      </Box>
      <Box
        sx={{
          width: { xs: '100%', sm: '89%' },
          mx: 'auto',
        }}>
        <Typography
          sx={{
            color: '#BD2932',
            textAlign: 'center',
            mb: 1,
            fontSize: 14,
            fontWeight: 500,
          }}>
          Sorry, this PAN has failed the AML check
        </Typography>
        <Typography
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            mt: 2,
            fontSize: 16,
            fontWeight: 500,
            mb: 0.5,
          }}>
          Further Information:
        </Typography>
        <Box
          sx={{
            width: '100%',
            height: '25vh',
            overflowY: 'auto',
            overflowWrap: 'anywhere',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}>
          <Typography
            sx={{
              color: 'rgba(0,0,0,0.7)',
              textAlign: 'start',
              m: 2,
              fontSize: 14,
              fontWeight: 500,
            }}>
            {FURTHER_INFORMATION || ''}
          </Typography>
          <Typography
            sx={{
              color: 'primary.main',
              textAlign: 'start',
              ml: 2,
              fontSize: 16,
              fontWeight: 600,
            }}>
            Reference Links
          </Typography>
          <Typography
            sx={{
              color: 'rgb(0, 0, 255)',
              textAlign: 'start',
              fontSize: 14,
              fontWeight: 500,
              m: 2,
              mt: 0.5,
            }}>
            {EXTERNAL_SOURCES || ''}
          </Typography>
        </Box>
        <Typography
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            fontSize: 14,
            fontWeight: 500,
            mt: 3,
            mb: 0,
          }}>
          If you still wish to proceed with this PAN, please provide reason below.
        </Typography>
        <Formik
          initialValues={amlPopupInitialValues}
          onSubmit={onSubmit}
          validationSchema={amlPopupValidation}>
          {({ handleSubmit, values }) => (
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
                '.MuiTypography-root': {
                  fontSize: 15,
                  fontWeight: 500,
                },
              }}>
              <MFTextField
                name="amlComments"
                multiline
                rows={3}
                inputProps={{
                  maxLength: 1024,
                }}
                placeholder="Type here..."
                displayCharecterCounter={'1024'}
                sx={{
                  color: 'rgba(0,0,0,0.7)',
                  pl: 0.5,
                  pt: 0.5,
                  '&.MuiInputBase-root': {
                    fontSize: 14,
                    fontWeight: 500,
                  },
                }}
              />
              <MFCheckbox
                name={`amlAcknowledgement`}
                label="I understand the risks and acknowledge to proceed further."
                sx={{ mt: 1 }}
              />
              {values.amlAcknowledgement && displayDocInfo && (
                <Typography
                  sx={{
                    color: 'primary.main',
                    textAlign: 'center',
                    fontSize: 14,
                    fontWeight: 500,
                    mt: 1,
                    mb: 0,
                  }}>
                  Please upload compliance document in document details.
                </Typography>
              )}
              <Grid container sx={{ mt: 3, mb: 1, justifyContent: 'center', gap: 1.5 }}>
                <Button
                  onClick={() => {
                    handleClose();
                  }}
                  variant="outlined"
                  sx={{
                    fontSize: 15,
                    color: 'primary.main',
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 500,
                  }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: 15,
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 400,
                  }}
                  type="submit">
                  Proceed
                </Button>
              </Grid>
            </Box>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
}
export function AmlDetailsFields({
  amlCheck,
  amlCommentedRole,
  amlComments,
}: {
  amlCheck: boolean | undefined;
  amlCommentedRole: string | undefined;
  amlComments: string | undefined;
}): JSX.Element {
  return (
    <Grid
      item
      container
      rowSpacing={3}
      pb={2}
      columnSpacing={13}
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{ paddingLeft: { xs: 0, sm: '10%' } }}>
      <KeyValue title={'Aml Check'} description={amlCheck?.toString().toUpperCase() || ''} />
      <KeyValue title={'Commented By'} description={amlCommentedRole?.toUpperCase() || ''} />
      <Grid item xs={12}>
        <Item>{'Comments'}</Item>
        <ItemDetails> {amlComments || '-'}</ItemDetails>
      </Grid>
    </Grid>
  );
}
export function AmlDetails({
  applicants = [],
  applicationType,
}: {
  applicants: Partial<Applicant>[];
  applicationType: string;
}): JSX.Element {
  return (
    <>
      {!applicants.every((applicant) => applicant.amlCheck) && (
        <Box
          sx={{
            bgcolor: 'white',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
            borderRadius: '10px',
          }}
          my={5}>
          <Box sx={{ p: 2 }}>
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                  Aml Check Details
                </Typography>
              </Grid>
              {applicants
                .filter((applicant) => !applicant.amlCheck)
                .map((applicant, index: number) => {
                  const title = [
                    'First Applicant Details',
                    'Second Applicant Details',
                    'Third Applicant Details',
                  ][Number(applicant.applicant_type) - 1];
                  return (
                    <React.Fragment key={applicant.id}>
                      {applicationType !== APPLICATION_TYPE.NON_INDIVIDUAL && (
                        <SubHeading
                          sx={{
                            color: 'common.black',
                            letterSpacing: 0.5 + 'px',
                            padding: { xs: '10px 10px', sm: '10px 30px' },
                          }}>
                          {title}
                        </SubHeading>
                      )}
                      <AmlDetailsFields
                        amlCheck={applicant.amlCheck}
                        amlCommentedRole={applicant.amlCommentedRole}
                        amlComments={applicant.amlComments}
                      />
                    </React.Fragment>
                  );
                })}
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
}

export const LoadingDialog = ({
  loadingPopup,
  onLoadingPopupClose,
  loaderText = 'Loading',
}: {
  loadingPopup: boolean;
  onLoadingPopupClose: () => void;
  loaderText?: string;
}): JSX.Element => {
  return (
    <Dialog
      onClose={onLoadingPopupClose}
      open={loadingPopup}
      sx={{
        '.MuiPaper-root ': {
          p: 4,
          width: { xs: '70%', sm: '70%' },
        },
      }}>
      <Box
        sx={{
          width: { xs: '100%', sm: '80%' },
          mx: 'auto',
          '.MuiTypography-root': {
            fontSize: 20,
            fontWeight: 500,
          },
        }}>
        <Typography sx={{ color: 'primary.main', lineHeight: '35px', textAlign: 'center' }}>
          {loaderText}...
        </Typography>
      </Box>
    </Dialog>
  );
};

export const CopyLinkFromApplication = ({
  handleClose,
  applicationRefsList,
  open,
  checkPoa,
  checkNI,
}: {
  handleClose: () => void;
  applicationRefsList: investmentDetailsAplicationRef[];
  open: boolean;
  checkPoa: boolean;
  checkNI: boolean;
}): JSX.Element => {
  const [tooltip, setTooltip] = useState('Click to Copy');
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      sx={{
        '.MuiPaper-root ': {
          width: { xs: '70%', sm: '70%' },
        },
      }}>
      <Grid
        item
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={4}
        pb={2}>
        <Typography sx={{ color: 'primary.main', fontSize: '20px', fontWeight: 500 }}>
          Get Link
        </Typography>
        <IconButton onClick={handleClose} aria-label="Close">
          <CloseIcon fontSize="medium" />
        </IconButton>
      </Grid>

      {applicationRefsList &&
        applicationRefsList.map((ref) => {
          const copyLinkAriaLabel = getEsignLinkCopyAriaLabel(ref.name, ref.signatureBy);

          return (
            <React.Fragment key={ref.id}>
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                px={4}
                py={1}
                sx={{
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                  ':last-of-type': {
                    mb: 5,
                  },
                }}>
                <Typography
                  sx={{
                    color: 'rgba(41, 49, 57, 0.7)',
                    fontSize: '18px',
                    fontWeight: 500,
                  }}>
                  Copy Link For {ref.name}
                </Typography>
                <Tooltip title={tooltip}>
                  <IconButton
                    aria-label={copyLinkAriaLabel}
                    onMouseOver={() => {
                      setTooltip('Copy Link');
                    }}
                    onClick={() => {
                      setTooltip('Copied'),
                        navigator.clipboard.writeText(
                          checkNI &&
                            !checkPoa &&
                            [USER_ROLES.AUTHORISEDSIGNATORY, USER_ROLES.GROUPSIGNATORY].includes(
                              ref?.signatureBy as USER_ROLES
                            )
                            ? `${window.location.origin}/authorized-signatories-investment-details/${ref.referenceId}/fund-details`
                            : checkPoa
                            ? ref.invitationUrl
                            : ref?.signatureBy &&
                              ('fundManager' === ref.signatureBy ||
                                USER_ROLES.TRUSTEE === ref.signatureBy)
                            ? ref.invitationUrl
                            : `${window.location.origin}/investment-details/${ref.referenceId}/details`
                        );
                    }}>
                    <CardMedia
                      component="img"
                      src="/images/link-icon.svg"
                      alt=""
                      sx={{ width: '35px' }}
                    />
                  </IconButton>
                </Tooltip>
              </Grid>
            </React.Fragment>
          );
        })}
    </Dialog>
  );
};

export const CommonDocumentPreviewSection = ({
  updatedDocuments,
  authorisedSignatoryDetails,
  oldData,
  handleRoutePopupOpen,
}: {
  updatedDocuments: DocumentType[];
  authorisedSignatoryDetails?: null | AuthorisedSignatories;
  oldData?: null | AuthorisedSignatories;
  handleRoutePopupOpen?: (
    propertyName: string,
    newValue: string | null | number | undefined | FileType,
    oldValue: string | null | number | undefined | FileType,
    isDoc?: boolean
  ) => void;
}) => {
  return (
    <Grid
      container
      pt={updatedDocuments && updatedDocuments.length && 2}
      pb={updatedDocuments && updatedDocuments.length && 5}
      columnSpacing={13}
      sx={{ pl: { xs: 0, sm: 7, md: 10, lg: 13 } }}>
      {updatedDocuments.length ? (
        updatedDocuments.map((document, index: number) => {
          return (
            <React.Fragment key={document.id}>
              <Grid
                item
                xs={12}
                sm={6}
                md={document.file ? 6 : 12}
                sx={{
                  mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                }}>
                <Item>{getFieldTitle[document.documentType]}</Item>
                <ItemDetails>
                  {document.documentName?.toLowerCase() ===
                  getFieldTitle[document.documentType]?.toLowerCase()
                    ? document.file?.name
                    : document.documentName}
                  <span>
                    {oldData &&
                      !applicationComparison(
                        oldData?.signatoryDocuments?.[index]?.documentId,
                        authorisedSignatoryDetails?.signatoryDocuments?.[index]?.documentId
                      ) && (
                        <Typography
                          component="span"
                          sx={{ pl: 1, pt: 1, ':hover': { cursor: 'pointer' } }}>
                          <ManageAccountsIcon
                            color="info"
                            fontSize="small"
                            onClick={() => {
                              oldData &&
                                handleRoutePopupOpen &&
                                !applicationComparison(
                                  oldData.signatoryDocuments?.[index]?.documentId,
                                  authorisedSignatoryDetails?.signatoryDocuments?.[index]
                                    ?.documentId
                                ) &&
                                handleRoutePopupOpen(
                                  authorisedSignatoryDetails?.signatoryDocuments?.[index]
                                    ?.documentName || '',
                                  authorisedSignatoryDetails?.signatoryDocuments?.[index]?.file,
                                  oldData?.signatoryDocuments?.[index]?.file,
                                  true
                                );
                            }}
                          />
                        </Typography>
                      )}
                  </span>
                </ItemDetails>
              </Grid>
              {document.file && (
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      display: 'flex',
                      mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                      flexDirection: { sm: 'column', xs: 'row', md: 'row' },
                    }}>
                    <Button
                      variant="contained"
                      sx={{
                        color: 'common.white',
                        // minWidth: { xs: '90%', sm: '100%', md: '70%' },
                        minWidth: '70%',
                        // mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                        fontWeight: 600,
                        lineHeight: 1.5,
                      }}
                      aria-label={getDocumentActionAriaLabel(
                        'view',
                        document.documentName,
                        document.documentType,
                        getFieldTitle[document.documentType]
                      )}
                      onClick={() => window.open(document.file?.viewUrl)}>
                      View
                    </Button>
                    <Tooltip
                      title={getDocumentActionAriaLabel(
                        'download',
                        document.documentName,
                        document.documentType,
                        getFieldTitle[document.documentType]
                      )}>
                      <IconButton
                        aria-label={getDocumentActionAriaLabel(
                          'download',
                          document.documentName,
                          document.documentType,
                          getFieldTitle[document.documentType]
                        )}
                        sx={{
                          // p: 0,
                          // pl: 1.5,
                          ':hover': {
                            bgcolor: '#F4FCFC',
                          },
                          cursor: 'pointer',
                          pointerEvents: 'all',
                          // mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                        }}
                        onClick={() => window.open(document.file?.url)}>
                        <CardMedia
                          component="img"
                          src={'/images/download-icon.png'}
                          alt=""
                          sx={{ width: '25px' }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>
              )}
            </React.Fragment>
          );
        })
      ) : (
        <Box
          sx={{
            width: '100%',
            textAlign: 'center',
          }}>
          <Typography
            sx={{
              // fontSize: 18,
              // fontWeight: 500,
              color: '#228287',
              // mt: { lg: 14, xs: 4 },
              // mb: { xs: 4 },
            }}>
            No Document
          </Typography>
        </Box>
      )}
    </Grid>
  );
};
export const TinVerificationComponent = ({
  fieldname,
  isFieldDisabled,
  setValues,
  index,
  formvalues,
  targetField,
  createdAt,
  // tinExist,
  loading,
  isTinVerified,
  handleVerification,
  tinVerification,
  tinIndex,
  documents,
  formVal,
  isDocumentCheck = false,
}: {
  fieldname: string;
  isFieldDisabled: boolean;
  setValues: (values: any) => void;
  index: number;
  formvalues: any;
  targetField: string;
  createdAt: string;
  // tinExist?: boolean | null;
  loading: boolean;
  isTinVerified: boolean | null;
  handleVerification: any;
  tinVerification: tinValidationProps[] | null;
  tinIndex: number;
  documents: newDocumentProps[];
  formVal?: Values;
  isDocumentCheck?: boolean;
}): JSX.Element => {
  const { setFieldValue } = useFormikContext<Values>();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const getLabel = (documentName: string): string => {
    return `${documentName} * `;
  };
  const dateFeatureToggles = useFeatureToggles();

  const { tin_declaration_validation_date } = dateFeatureToggles;
  return (
    <>
      {checkValidationBasedOnDate(createdAt || '', tin_declaration_validation_date) && (
        <>
          {/* <Grid
            item
            xs={12}
            display="flex"
            justifyContent="space-between"
            sx={{
              width: '100%',
              flexDirection: { xs: 'column-reverse', sm: 'row' },
              alignItems: { xs: 'flex-start', sm: 'center' },
            }}>
            <Grid
              xs={12}
              sm={6}
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}>
              {!isDocumentCheck && (
                <LoadingButton
                  loadingPosition="end"
                  loading={loading}
                  disabled={[true, false].includes(isTinVerified as boolean) || loading}
                  variant="contained"
                  sx={{ fontWeight: 500, fontSize: 14, width: '100%' }}
                  onClick={() =>
                    handleVerification(formvalues, tinIndex, tinVerification, setValues)
                  }>
                  {tinIndex == 0 ? 'Verify' : 'Verify Tin'}
                </LoadingButton>
              )}
            </Grid>
            {isTinVerified !== null && !isDocumentCheck && (
              <Grid sm={6} xs={12} sx={{ position: 'relative', bottom: 10, mb: { xs: 2, sm: 0 } }}>
                <Typography
                  component="div"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    padding: { xs: 0, sm: '10px 20px' },
                    borderRadius: '5px',
                    alignItems: 'flex-start',
                    mt: 2,
                    width: '100%',
                    boxSizing: 'border-box',
                  }}>
                  <InfoOutlinedIcon color="info" fontSize="small" />
                  <Typography
                    sx={{
                      color: 'rgba(41, 49, 57, 0.7)',
                      fontSize: '13px',
                      fontWeight: 500,
                      ml: 1,
                    }}>
                    {isTinVerified === true
                      ? `${tinIndex == 0 ? 'Verified' : 'Tin verified'} successfully`
                      : isTinVerified === false
                      ? `${tinIndex == 0 ? '' : 'Tin'} verification failed`
                      : ''}
                  </Typography>
                </Typography>
              </Grid>
            )}
          </Grid> */}
          <Grid item xs={12}></Grid>
          {isTinVerified == false &&
            (!isFieldDisabled ? (
              documents
                .map((document, doc_index) => {
                  if (document.documentType === `tin_declaration_${tinIndex + 1}`) {
                    const {
                      documentType,
                      documentName,
                      documentsList = [],
                      multipleFiles,
                      options,
                      required,
                      downloadTemplate,
                    } = document;
                    return (
                      <React.Fragment key={doc_index}>
                        <Grid item xs={12} sm={6}>
                          {options &&
                            documentsList.map((doc, index) => (
                              <React.Fragment key={index}>
                                <Grid xs={12} sm={12}>
                                  <MFSelectField
                                    name={`applicants.${0}.documents.${doc_index}.documentsList.${index}.documentName`}
                                    label={getLabel(documentName)}
                                    items={options.map((item: string) => ({
                                      key: item,
                                      value: item,
                                    }))}
                                    applyLabelStyles={true}
                                  />
                                </Grid>
                              </React.Fragment>
                            ))}
                          {!options && (
                            <Typography
                              sx={{
                                color: 'primary.main',
                                fontWeight: 500,
                                mt: 6,
                              }}>
                              {`${documentName} *`}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6} display="flex" flexDirection="column">
                          {documentsList.map((doc, index) => (
                            <React.Fragment key={doc.uniqueKey}>
                              <FileUpload
                                labelId={`${documentType}-${index}-${doc_index}-label`}
                                ariaLabel={`${documentName}${
                                  required === 'true' ? ' (required)' : ''
                                }`}
                                onFileChange={(value, documentId, removeFile) => {
                                  if (formVal) {
                                    const { file, ...rest } =
                                      formVal.applicants[0].documents[doc_index].documentsList[
                                        index
                                      ];
                                    setFieldValue(
                                      `applicants.${0}.documents.${doc_index}.documentsList.${index}`,
                                      {
                                        ...rest,
                                        documentId,
                                        ...(!removeFile && { file }),
                                        // errorOnUpload:
                                        //   errorOnUpload || document_object.errorOnUpload,
                                      }
                                    );
                                  }
                                }}
                                name={`applicants.${0}.documents.${doc_index}.documentsList.${index}.documentId`}
                                documentData={doc}
                                // disabled={isFieldDisabled}
                                // onFileUpload={handleUpload}
                                // onFileUploaded={handleUploaded}
                              />

                              {index > 0 && !doc.documentId && (
                                <DeleteOutlineIcon
                                  onClick={() => {
                                    if (formVal) {
                                      const getDocs = formVal.applicants[0].documents[
                                        doc_index
                                      ].documentsList.filter((_, i) => i !== index);
                                      setFieldValue(
                                        `applicants.${0}.documents.${doc_index}.documentsList`,
                                        getDocs
                                      );
                                    }
                                  }}
                                  color="error"
                                  sx={{
                                    alignSelf: 'end',
                                    position: 'relative',
                                    bottom: '50px',
                                    left: '22px',
                                    cursor: 'pointer',
                                  }}
                                />
                              )}
                            </React.Fragment>
                          ))}
                          {downloadTemplate && (
                            <Box sx={{ textAlign: 'center', mt: 3 }}>
                              <Button
                                variant="contained"
                                aria-label={getDocumentActionAriaLabel(
                                  'downloadTemplate',
                                  documentName,
                                  documentType
                                )}
                                sx={{
                                  color: 'common.white',
                                  // minWidth: '350px',
                                  width: '100%',
                                  fontWeight: 600,
                                  lineHeight: 1,
                                  // mt: { xs: 1 },
                                  fontSize: '12px',
                                }}
                                disabled={isFieldDisabled}
                                onClick={async () => {
                                  window.open(downloadTemplate);
                                }}>
                                Download template
                              </Button>
                            </Box>
                          )}
                          {multipleFiles === 'true' && documentsList.length < 2 && (
                            <Typography
                              component="button"
                              type="button"
                              aria-label="Add another document"
                              onClick={() => {
                                if (formVal) {
                                  const currentDocTypeListLength =
                                    formVal.applicants[0].documents[doc_index].documentsList.length;
                                  const {
                                    required = true,
                                    documentType,
                                    documentName,
                                    documentId,
                                  } = formVal.applicants[0].documents[doc_index].documentsList[
                                    currentDocTypeListLength - 1
                                  ];
                                  try {
                                    if (!documentId) {
                                      throw Error(
                                        'Please upload the first document to add more documents'
                                      );
                                    }
                                    setFieldValue(
                                      `applicants.${'0'}.documents.${doc_index}.documentsList`,
                                      [
                                        ...formVal.applicants[0].documents[doc_index].documentsList,
                                        {
                                          ...document_object,
                                          uniqueKey:
                                            '0'.toString() +
                                            '-' +
                                            doc_index.toString() +
                                            '-' +
                                            currentDocTypeListLength.toString(),
                                          documentType,
                                          documentName,
                                          required,
                                        },
                                      ]
                                    );
                                  } catch (e) {
                                    dispatch(showError((e as Error).message));
                                  }
                                }
                              }}
                              sx={{
                                color: '#417850',
                                fontSize: '12px',
                                fontWeight: 500,
                                textDecoration: 'underline',
                                alignSelf: 'end',
                                cursor: 'pointer',
                                border: 'none',
                                background: 'none',
                                padding: 0,
                              }}>
                              {'Add another document'}
                            </Typography>
                          )}
                        </Grid>
                      </React.Fragment>
                    );
                  }
                })
                .filter((ele) => ele)
            ) : (
              <DocumentPreview
                application={
                  {
                    ...application,
                    applicants: [...(application?.applicants || [])].map((applicant) => {
                      return {
                        ...applicant,
                        documents:
                          applicant.documents?.filter(
                            (doc) => doc.documentType === `tin_declaration_${tinIndex + 1}`
                          ) || [],
                      };
                    }),
                  } as ApplicationProps
                }
                isTin={true}
              />
            ))}
        </>
      )}
    </>
  );
};
